import type { Entry } from "@/shared/types/entries";
import {
	ResponsiveDialog,
	ResponsiveDialogContent,
} from "@/v2/components/ui/responsive-dialog";
import { TooltipButton } from "@/v2/components/ui/tooltip-button";
import { ActionForm, type ActionFormSubmit } from "./action-dialog/ActionForm";

export interface GroupDialogProps {
	entries: Entry[];
	open: boolean;
	onOpenChange: (open: boolean) => void;
	conflicts?: { field: string; values: string[] }[];
	defaultIncludeUnits?: boolean;
	onSubmit: (values: ActionFormSubmit) => void;
}

export function GroupDialog({
	entries,
	open,
	onOpenChange,
	conflicts,
	defaultIncludeUnits = true,
	onSubmit,
}: GroupDialogProps) {
	const formId = "group-entries-form";
	return (
		<ResponsiveDialog open={open} onOpenChange={onOpenChange}>
			<ResponsiveDialogContent
				title="Group"
				footer={
					<div className="flex justify-end items-center gap-2">
						<TooltipButton
							variant="outline"
							size="sm"
							onClick={() => onOpenChange(false)}
							tooltip="Cancel"
						>
							Cancel
						</TooltipButton>
						<TooltipButton
							type="submit"
							form={formId}
							size="sm"
							tooltip="Group entries"
						>
							Group entries
						</TooltipButton>
					</div>
				}
			>
				{entries.length > 0 && (
					<ActionForm
						formId={formId}
						entries={entries}
						conflicts={conflicts}
						showIncludeUnits
						defaultIncludeUnits={defaultIncludeUnits}
						onSubmit={onSubmit}
					/>
				)}
			</ResponsiveDialogContent>
		</ResponsiveDialog>
	);
}
